import * as React from "react";
import "moment/locale/fr";
import Page from "src/presentations/views/PageView";
import { Link, RouteComponentProps, useParams } from "react-router-dom";
import { defaults } from "react-chartjs-2";
import { multipleQueries } from "src/utils/graph/GraphExplorer";
import { register } from "timeago.js";
import { localeENFunc } from "src/utils/timeago";
import withSession from "src/utils/withSession";
import * as SC from "../../../companies/Company_styled";
import Scrollbars from "react-custom-scrollbars";
import DeleteModal from "src/presentations/widgets/DeleteModal";
import { toast } from "react-toastify";
import Loader from "src/presentations/widgets/Loader";
import { translate } from "src/utils/translate";
import Video from "src/components/Video";
register("en", localeENFunc);
defaults.global.defaultFontFamily = "Gelion";
import Text from "src/presentations/elements/Text";
import { useHistory, useLocation } from "react-router-dom";
import i18n from "src/assets/messages";
import styled from "styled-components";
import Table from "src/presentations/collections/Table/Columns";
import { IUserCompany } from "src/pages/companies/createCompany";
import * as moment from "moment";
import { parse } from "query-string";
import { Calendar, Database, MessageSquare, X } from "react-feather";
import { Row as RowBT, Col } from "react-bootstrap";

import loadable from "@loadable/component";
const Tab = loadable(() => import("src/presentations/widgets/Tab"));

export type Cell = string | number | undefined;

const StyledTable = styled.div`
  .table-simple td {
    vertical-align: middle !important;
    padding: 5px 10px !important;
    border-bottom: 1px solid #fff;
  }
`;

export interface Row {
    statusCode: number;
    value: string;
    type: string;
}
interface PropsInterface extends RouteComponentProps<{}> {
    session: any;
}

export interface IcompaniesRows {
    name: string;
    description: string;
    task: string;
    logoURL: string;
    color: string;
    id: string;
    companyUsers: IUserCompany[];
}

interface IdocsRows {
    id: string;
    amount: number;
    date: string;
    label: string;
    powensId: string;
}

const Transactions = (props: PropsInterface) => {
    const { search } = useLocation();

    const [showModal, setshowModal] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [ElementId] = React.useState<string>("");
    const [documents, setDocuments] = React.useState<IdocsRows[]>([]);
    const [transactionCount, setTransactionCount] = React.useState(0);
    const [showEC, setshowEC] = React.useState(false);
    const [showBalise, setshowBalise] = React.useState(false);
    const [showMarketplace, setshowMarketplace] = React.useState(false);
    const { push, location } = useHistory();
    const queryURL = new URLSearchParams(search);
    const [ready] = React.useState(true);
    const { companyId, language, bankId }: any = useParams();
    const [company, setCompany] = React.useState({ folderNumber: '', name: '' });
    const [bank, setBank] = React.useState({ name: '', number: '', balance: 0, iban: '' });
    const [pages, setPage] = React.useState(
        Number(queryURL.get("page")) ? Number(queryURL.get("page")) : 1
    );
    const [dateString, setDateString] = React.useState({ startDate: '', endDate: '' });

    const handleDateChange = (event: any) => {
        const { id, value } = event.target;
        setDateString((prevDateRange) => ({
          ...prevDateRange,
          [id]: value,
        }));
      };


    const paramsDefault = {
        noDataIndication: i18n.t("resultEmptyExtenxion"),
        containerClass: "table-simple table-simple-raw",
        bordered: false,
        striped: false,
        hover: false,
        rowClasses: "listRow",
    };

    React.useEffect(() => {
        document.title = `Bank`;
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('startDate') && urlParams.has('endDate')) {
            const startDate = urlParams.get('startDate') ?? '';
            const endDate = urlParams.get('endDate') ?? '';
            setDateString({ startDate, endDate });
            getData({ startDate, endDate })
        } else {
            getData();
        }
      }, [pages]);

    React.useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        if (dateString.startDate !== "") {
          urlParams.set("startDate", dateString.startDate);
        }

        if (dateString.endDate !== "") {
          urlParams.set("endDate", dateString.endDate);
        }
        
        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.history.replaceState({}, "", newUrl);
    }, [dateString.startDate, dateString.endDate]);

    const getData = async (dateStringInternal={ startDate: '', endDate: '' }) => {
        setLoading(true);
        const prms: any = parse(location.search);

        let offset;
        if (prms.page) {
            offset = ((prms.page || 1) - 1) * 30;
        }
        const result: any = await multipleQueries([
            {
                type: "findOne",
                target: 'Company',
                alias: 'row',
                id: companyId,
                output: {
                  id: true,
                  name: true,
                  accessToken: true,
                  folderNumber: true,
                  cabinet: {
                    id: true,
                    name: true
                  },
                },
            },
            {
                type: "findOne",
                target: 'Bank',
                alias: 'bank',
                id: bankId,
                output: {
                  number: true,
                  iban: true,
                  balance: true,
                  name: true,
                },
            },
            {
                type: "findAll",
                target: "Transaction",
                alias: "rows",
                offset,
                limit: 100,
                order: [['date', 'DESC']],
                where: {
                    companyId, bankId,
                    date_gte: dateStringInternal.startDate ? new Date(dateStringInternal.startDate).toISOString() : "",
                    date_lte: dateStringInternal.endDate ? new Date(dateStringInternal.endDate).toISOString() : "",
                },
                output: {
                    id: true,
                    powensId: true,
                    label: true,
                    amount: true,
                    date: true,
                },
            },
            {
                type: "count",
                target: "Transaction",
                alias: "transactionCount",
                where: {
                    companyId, bankId,
                    date_gte: dateStringInternal.startDate ? new Date(dateStringInternal.startDate).toISOString() : "",
                    date_lte: dateStringInternal.endDate ? new Date(dateStringInternal.endDate).toISOString() : "",
                },
            },
        ]);

        const DateObj = new Date(result.date);
        DateObj.setDate(DateObj.getDate() + 15);
        setTransactionCount(result.transactionCount)
        setDocuments(result.rows);
        setCompany(result.row)
        setBank(result.bank)
        setLoading(false);
    };

    const handlePageChange: any = (pageNumber: number) => {
        const currentUrlParams = new URLSearchParams(location.search);
        if (pageNumber) {
            currentUrlParams.set("page", pageNumber.toString());
            setPage(Number(pageNumber));
            push(location.pathname + "?" + currentUrlParams.toString());
        }
    };

    const deleteModal = async () => {
        setshowModal(false);
        await getData(dateString);
        toast(translate(language, "Company deleted!"), { autoClose: 2000 });
    };

    const columnsModels = () => [
        {
            dataField: "date",
            text: translate(language, "Date d'opération"),
            headerStyle: { width: "15%" },
            formatter: (cell: any, row: any) => {
                return (
                    <span>
                        <Calendar size={15} style={{verticalAlign: "sub", marginRight: "10px" }} />
                        {`${moment(new Date(cell))
                            .locale(language)
                            .format("DD/MM/YYYY")}`}
                    </span>
                );
            },
        },

        {
            dataField: "label",
            text: translate(language, "Libellé"),
            headerStyle: { width: "45%" },
            formatter: (cell: any, row: any) => {
                if (cell) {
                    return (
                        <span>
                            <MessageSquare size={15} style={{verticalAlign: "sub", marginRight: "10px" }} />
                            <Text useWordBoundary={200} trucanteType="middle" text={cell} />
                        </span>
                    );
                }
                return <></>;
            },
        },
        {
            dataField: "amount",
            text: translate(language, "Débit"),
            headerStyle: { width: "10%", textAlign: "right" },
            formatter: (cell: number, row: any) => {
                if (cell < 0) {
                    return (
                        <div style={{ textAlign: "right"}}>{cell.toLocaleString('fr-FR', {
                            style: 'currency',
                            currency: 'EUR',
                          })}</div>
                    );
                }
                return <></>;
            },
        },

        {
            dataField: "amount",
            text: translate(language, "Crédit"),
            headerStyle: { width: "10%", textAlign: "right" },
            formatter: (cell: any, row: any) => {
                if (cell > 0) {
                    return (
                        <div style={{ textAlign: "right"}}>{cell.toLocaleString('fr-FR', {
                            style: 'currency',
                            currency: 'EUR',
                          })}</div>
                    );
                }
                return <></>;
            },
        },

        {
            dataField: "amount",
            text: translate(language, "Type"),
            headerStyle: { width: "15%", textAlign: "right" },
            formatter: (cell: any, row: any) => {
                if (cell > 0) {
                    return (
                        <div style={{ textAlign: "right"}}>Crédit</div>
                    );
                }
                return <div style={{ textAlign: "right"}}>Débit</div>;
            },
        },

        {
            dataField: "amount",
            text: "",
            headerStyle: { width: "5%", textAlign: "right" },
            formatter: (cell: any, row: any) => {
                return <></>;
            },
        },
    ];

    const renderFilters = () => (
        <RowBT>
          <Col md={12}>
            <Tab
              icons={[
                <Database style={{ marginRight: 5 }} size={17} key={0} />,
              ]}
              datas={
                [
                    loading === true ? '-' : `${bank?.name || ''} (${bank?.number})`,
                ] as string[]
              }
              active={0}
              hideBar={false}
              onChangeTab={() => <></>}
            />
          </Col>
        </RowBT>
    );

    const getFormatData = (TRANSACTIONS: any, DTSTART: any, DTEND: any, BANKID: any, GUICHET: any, ACCOUNTID: any, BALANCEEND: any) => {
        const DTSERVER = Math.floor(Date.now() / 1000);
        const CURRDATE = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        
        const response = `OFXHEADER:100
    DATA:OFXSGML
    VERSION:102
    SECURITY:NONE
    ENCODING:USASCII
    CHARSET:1252
    COMPRESSION:NONE
    OLDFILEUID:NONE
    NEWFILEUID:NONE
    <OFX>
    <SIGNONMSGSRSV1>
    <SONRS>
    <STATUS>
    <CODE>0
    <SEVERITY>INFO
    </STATUS>
    <DTSERVER>${DTSERVER}
    <LANGUAGE>FRA
    </SONRS>
    </SIGNONMSGSRSV1>
    <BANKMSGSRSV1>
    <STMTTRNRS>
    <TRNUID>00
    <STATUS>
    <CODE>0
    <SEVERITY>INFO
    </STATUS>
    <STMTRS>
    <CURDEF>EUR
    <BANKACCTFROM>
    <BANKID>${BANKID}
    <BRANCHID>${GUICHET}
    <ACCTID>${ACCOUNTID}
    <ACCTTYPE>CHECKING
    </BANKACCTFROM>
    <BANKTRANLIST>
    <DTSTART>${DTSTART}
    <DTEND>${DTEND}
    ${TRANSACTIONS}
    </BANKTRANLIST>
    <LEDGERBAL>
    <BALAMT>${BALANCEEND}
    <DTASOF>${CURRDATE}
    </LEDGERBAL>
    <AVAILBAL>
    <BALAMT>${BALANCEEND}
    <DTASOF>${CURRDATE}
    </AVAILBAL>
    </STMTRS>
    </STMTTRNRS>
    </BANKMSGSRSV1>
    </OFX>
    `;
        return response;
    }
    
     const generateNumericString = (length: number) =>  {
      let result = '';
      const characters = '0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charactersLength);
        result += characters.charAt(randomIndex);
      }
      return result;
    }
    
    const getTransaction = (change: any, date: any, amount: any, libelle: any, memo: any)  =>{
        date = date.substr(4) + date.substr(0, 4);

      const idTrans = generateNumericString(39)
      const transaction = `<STMTTRN>
    <TRNTYPE>${change}
    <DTPOSTED>${date}
    <TRNAMT>${amount}
    <FITID>${idTrans}
    <NAME>${libelle}
    <MEMO>${libelle}
    </STMTTRN>`;
      return transaction;
    }

    
    const GenerateOFX = () => {
        let TRANSACTIONS = ''
        documents
        .map((transaction) => {
          TRANSACTIONS += getTransaction(
            transaction.amount > 0 ? "CREDIT" : "DEBIT",
            new Date(transaction.date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, ''),
            transaction.amount,
            transaction.label,
            transaction.label
          )
        })

        const cT = documents
        const BALANCEEND = bank.balance || 0;
        const DTSTART = new Date(cT[0].date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');
        const DTEND = new Date(cT[cT.length - 1].date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '');

        let iban: string = bank.iban;
        iban = iban.replace(' ', '');
        let BANKID = iban.substring(4, 9);
        let GUICHET = iban.substring(9, 14);
        let ACCOUNTID = iban.substring(14, 25);

        BANKID = String(BANKID).padStart(5, '0');
        GUICHET = String(GUICHET).padStart(5, '0');
        ACCOUNTID = String(ACCOUNTID).padStart(11, '0');
        const ofxContent = getFormatData(TRANSACTIONS, DTSTART, DTEND, BANKID, GUICHET, ACCOUNTID, BALANCEEND);

        const blob = new Blob([ofxContent], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${bank.name}.ofx`;
        link.click();
        URL.revokeObjectURL(url);
    }

    const handleResetDates = (dateField: string) => {
        setDateString(prev => ({ ...prev, [dateField]: '' }));
      };

    return (
        <SC.StyleCompany>
            <div className="companyWrap">
                <ol className="breadcrumb">
                    <li>
                        <Link to={`/${language}`}>Home</Link>
                    </li>
                    <li>
                        <Link to={`/${language}/companies/${companyId}/banks`}>Comptes bancaires</Link>
                    </li>
                    <li className="active">Transactions</li>
                </ol>
                <DeleteModal
                    show={showModal}
                    onHide={() => setshowModal(false)}
                    target="Company"
                    id={ElementId}
                    onComfirm={deleteModal}
                />
                <h4 style={{ marginBottom: 30, marginLeft: 30 }}> { loading === true ? '-' : `${company?.folderNumber || ''} / ${company?.name || ''}`} </h4>
                <div style={{ marginBottom: 15 }} className="company-tab">{renderFilters()}</div>
                <div style={{ marginBottom: 15, marginLeft: 30, marginRight: 30, display: 'flex' }} className="well">
                    <div className="date-picker-wrap">
                        <input
                            className="date-picker"
                            type="date"
                            id="startDate"
                            value={dateString.startDate}
                            onChange={handleDateChange}
                        />
                        {dateString.startDate && (
                            <X
                            className="reset-icon"
                            onClick={() => handleResetDates('startDate')}
                            />
                        )}
                    </div>
                    <div className="date-picker-wrap">
                    <input
                            className="date-picker"
                            type="date"
                            id="endDate"
                            value={dateString.endDate}
                            onChange={handleDateChange}
                        />
                        {dateString.endDate && (
                            <X
                            className="reset-icon"
                            onClick={() => handleResetDates('endDate')}
                            />
                        )}
                    </div>
                    <button className="add-button" style={{ marginRight: '20px' }} onClick={() => getData(dateString)}>Appliquer un filtre</button>
                    <button className="add-button" onClick={() => GenerateOFX()}>Générer un fichier OFX</button>
                    <span className="total-data"  style={{ lineHeight: "40px", marginRight: "30px" }}>Total Transaction:{transactionCount}</span>
                    <span style={{ lineHeight: "40px" }}>
                      Balance actuelle: {`${bank.balance.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: 'EUR',
                        })}`}
                    </span>
                </div>
                <Page.Content>
                    {loading && (
                        <Loader textLabel={translate(language, "Chargement des transactions")} />
                    )}
                    {!loading && (
                        <Scrollbars
                            style={{ height: "calc(100vh - 275px)", width: "calc(100% )" }}
                            autoHide={true}
                        >
                            <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                                <StyledTable>
                                    <Table
                                        {...paramsDefault}
                                        ready={ready}
                                        loading={loading}
                                        datas={documents || []}
                                        columns={columnsModels() as any}
                                        selectColumn={false}
                                        pagination={{
                                            page: pages,
                                            sizePerPage: 100,
                                            onPageChange: handlePageChange,
                                            alwaysShowAllBtns: false,
                                        }}
                                        totalSize={transactionCount}
                                        striped={true}
                                        noDataIndication={translate(
                                            language,
                                            "No requests available"
                                        )}
                                        hover={true}
                                    />
                                </StyledTable>
                            </div>
                        </Scrollbars>
                    )}
                </Page.Content>
            </div>
            <Video
                show={showEC}
                videoURL={"https://youtu.be/D-UyXkzHtiA"}
                setshow={setshowEC}
            />
            <Video
                show={showBalise}
                videoURL={"https://youtu.be/TNwDWZr5XQs"}
                setshow={setshowBalise}
            />
            <Video
                show={showMarketplace}
                videoURL={"https://youtu.be/6ZDiVQK20Yw"}
                setshow={setshowMarketplace}
            />
        </SC.StyleCompany>
    );
};

export default withSession(Transactions);



// WEBPACK FOOTER //
// ./src/pages/company/bank/transaction/index.tsx